module.exports = __webpack_public_path__ + "img/ico-live-now.dd241e8f.png";